"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGPercentBar = void 0;
class CTGPercentBar extends Phaser.GameObjects.Container {
    constructor(scene, w, h, bg_color, fg_color) {
        super(scene);
        this.w = w;
        this.h = h;
        this.bg_color = bg_color;
        this.fg_color = fg_color;
        this.background = scene.add.sprite(0, 0, 'pixel').setOrigin(0, 0).setDisplaySize(w, h).setTint(bg_color);
        this.add(this.background);
        this.contents = scene.add.sprite(0, 0, 'pixel').setOrigin(0, 0).setDisplaySize(w, h).setTint(fg_color);
        this.add(this.contents);
        this.contents.setVisible(true);
    }
    set_percent(percent, invert = false) {
        if (invert)
            percent = 1 - percent;
        percent = Math.max(0, Math.min(1, percent));
        let height = Math.floor(this.h * percent);
        this.contents.displayHeight = height;
        this.contents.y = this.h - height;
    }
}
exports.CTGPercentBar = CTGPercentBar;
